/**
 * Fixed column widths for NoteListHeader and NoteListRow.
 * Shared so header labels align exactly with row data.
 */
export const METADATA_COL = {
  DURATION: 88,
  RESOLUTION: 88,
  SIZE: 72,
  DATE: 88,
  STARRED: 44,
  ACTIONS: 40,
} as const;

/**
 * Extended sort fields for the notes list.
 * 'created_at' and 'title' are handled server-side by the API.
 * 'duration' and 'is_favorite' are sorted client-side.
 */
export type NoteSortField = 'created_at' | 'title' | 'duration' | 'is_favorite';

/** Fields the API can sort on directly */
export const API_SORT_FIELDS = new Set<string>(['created_at', 'title']);
